// ==========================================================================
// groots core
// Author: Globalia
// Licensed under the WTFPL license
// ==========================================================================

// Declaration of groots namespace
window.groots = window.groots || {};

window.jquery = window.jQuery = window.$ = require('jquery'); // Will be removed

// Set Breakpoints Map
var sassToJs = require('sass-to-js');
window.groots.sassBreakpoints = sassToJs( document.querySelector('body'), { pseudoEl: ':before', cssProperty: 'content', debug: true } );

// Groots methods
window.groots.methods = {

    objectAssign : Object.assign || function (srcObj) { // eslint-disable-line
        for (var i = 1; i < arguments.length; i++) {
            for (var objProperty in arguments[i]) {
                if (Object.prototype.hasOwnProperty.call(arguments[i], objProperty)) srcObj[objProperty] = arguments[i][objProperty];
            }
        }
        return srcObj;
    },

    debounce : function (func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    },

    isVisible : function (el) {
        var windowWidth = window.innerWidth,
            windowHeight = window.innerHeight;
        if (windowWidth === null || windowHeight === null) return false;
        var rect = el.getBoundingClientRect();
        var elTop = rect.top;
        var elLeft = rect.left;
        var elWidth = rect.width;
        var elHeight = rect.height;
        return elTop < windowHeight && elTop + elHeight > 0 && elLeft < windowWidth && elLeft + elWidth > 0;
    },

    hasAttributeValue : function (el, attribute, value) {
        if (!el || !el.hasAttribute(attribute)) return;

        var values = el.getAttribute(attribute).split(' ');
        var existingIndex = values.indexOf(value);

        if (existingIndex >= 0) {
            return true;
        } else {
            return false;
        };
    },

    // Add or toggle an attribute value
    toggleAttributeValue : function (el, attribute, value, toggleClass) {
        if (toggleClass === undefined) toggleClass = false;
        if (!el || !el.hasAttribute(attribute)) return;

        var values = el.getAttribute(attribute).split(' ');
        var existingIndex = values.indexOf(value);

        if (existingIndex >= 0) values.splice(existingIndex, 1);
        else values.push(value);
        if (toggleClass) el.classList.toggle('gr-' + value);

        el.setAttribute(attribute, values.join(' '));
    },

    // Remove attribute value(s)
    removeAttributeValue : function (el, attribute, value, removeClass) {
        if (removeClass === undefined) removeClass = false;
        if (!el || !el.hasAttribute(attribute)) return;
        var values = el.getAttribute(attribute).split(' ');

        var valuesToRemove = value.split(' ');

        for (var i = valuesToRemove.length - 1; i >= 0; i--) {
            var existingIndex = values.indexOf(valuesToRemove[i]);
            if (existingIndex >= 0) values.splice(existingIndex, 1);
            if (removeClass) el.classList.remove('gr-' + valuesToRemove[i]);
        }

        el.setAttribute(attribute, values.join(' '));
    },

    // Wrap wrapper around nodes
    wrapAll : function (nodes, wrapper) {
        // Cache the current parent and previous sibling of the first node.
        var parent = nodes[0].parentNode;
        var previousSibling = nodes[0].previousSibling;

        // Place each node in wrapper.
        //  - If nodes is an array, we must increment the index we grab from
        //    after each loop.
        //  - If nodes is a NodeList, each node is automatically removed from
        //    the NodeList when it is removed from its parent with appendChild.
        for (var i = 0; nodes.length - i; wrapper.firstChild === nodes[0] && i++) {
            wrapper.appendChild(nodes[i]);
        }

        // Place the wrapper just after the cached previousSibling,
        // or if that is null, just before the first child.
        var nextSibling = previousSibling ? previousSibling.nextSibling : parent.firstChild;
        parent.insertBefore(wrapper, nextSibling);

        return wrapper;
    },

    // Check if viewport is smaller than breakpoint (based on breakpoints defined in SASS)
    maxWidth: function (breakpoint) {
        if (typeof (breakpoint) === 'undefined') breakpoint = 'md';

        return window.innerWidth < parseInt(window.groots.sassBreakpoints[breakpoint], 10);
    },

    isMobile : function (condition, breakpoint) {
        var isMobile = false,
            isTouch = false;

        function testBreakpoint() {
            if (typeof(breakpoint) === 'undefined') breakpoint = 'md';

            return window.innerWidth < parseInt(window.groots.sassBreakpoints[breakpoint], 10);
        }

        function testTouch() {
            return 'ontouchstart' in window ||
                window.DocumentTouch && document instanceof window.DocumentTouch ||
                navigator.maxTouchPoints > 0 ||
                window.navigator.msMaxTouchPoints > 0;
        }

        switch(condition) {
            case 'breakpoint':
                return testBreakpoint();
            case 'touch':
                return testTouch();
            default:
                return testTouch() && testBreakpoint();
        }
    }
}

// ==========================================================================
// Polyfills
// ==========================================================================

// Closest
if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
        var el = this;

        do {
            if (el.matches(s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}

